export enum BankIDMode {
  ThisDevice,
  OtherDevice,
}
